function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Radio, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Row, Col, Container } from "react-bootstrap";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SaveDrugData = function SaveDrugData(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? false : _ref$update;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    Object.entries(values).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      formData.append(key, value === undefined || value === '' || value === "null" || value === null ? '' : value);
    });
    axios.post(Common.baseApiUrl + "setdrugdata", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (update == true) {
      form.setFieldsValue({
        alcool: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.alcool) : "",
        amphetamine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.amphetamine) : "",
        benzodiazepine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.benzodiazepine) : "",
        cannabinoide: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.cannabinoide) : "",
        cocaine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.cocaine) : "",
        opiace: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.opiace) : "",
        ketamine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.ketamine) : "",
        methamphetamine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.methamphetamine) : "",
        barbiluriques: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.barbiluriques) : "",
        phenyclidine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.phenyclidine) : "",
        morphine: candidat.laboratory_result.drug_test != null ? parseInt(candidat.laboratory_result.drug_test.morphine) : ""
      });
    }
    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Alcool",
            name: "alcool",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Amphetamines",
            name: "amphetamine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Benzodiazepines",
            name: "benzodiazepine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Cannabinoides",
            name: "cannabinoide",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Opiaces",
            name: "opiace",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Cocaine",
            name: "cocaine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Ketamine",
            name: "ketamine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Methamphetamine",
            name: "methamphetamine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Barbiluriques",
            name: "barbiluriques",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Phenyclidine",
            name: "phenyclidine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Morphine",
            name: "morphine",
            children: /*#__PURE__*/_jsxs(Radio.Group, {
              buttonStyle: "solid",
              children: [/*#__PURE__*/_jsx(Radio.Button, {
                value: 0,
                children: "N\xE9gatif"
              }), /*#__PURE__*/_jsx(Radio.Button, {
                value: 1,
                children: "Positif"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })
  });
};
export default SaveDrugData;